export default {
  'exportDropdown.export': 'Dışa Aktar',
  'exportDropdown.exportExamResult': 'Sınav Sonuçlarını Dışa Aktar',
  'exportDropdown.exportExamStats': 'Sınav ve Soru Analizlerini Dışa Aktar',
};
